import clsx from 'clsx';

// Components
import Icon from '@/components/base/Icon';
import Tooltip from '@/components/base/Tooltip';
import H3 from '@/components/base/Headings/H3';

type ReportSectionTitleProps = {
    title: string;
    tooltip?: string;
    withBorder?: boolean;
};

const ReportSectionTitle = ({ title, tooltip, withBorder = true }: ReportSectionTitleProps) => {
    return (
        <div className="mb-7 flex w-full flex-col">
            <div
                className={clsx('flex w-full items-center', {
                    'border-b border-icoGray-300 pb-3 dark:border-icoDarkMode-beton': withBorder
                })}>
                <H3>{title}</H3>
                {tooltip ? (
                    <div className="pl-3">
                        <Tooltip
                            content={tooltip}
                            placement="top"
                            interactive={true}
                            popperOptions={{
                                strategy: 'fixed'
                            }}>
                            <Icon
                                icon="info"
                                className="align-middle text-xs leading-none text-icoGray-400 hover:text-icoGray-500 dark:text-icoDarkMode-wolf"
                            />
                        </Tooltip>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default ReportSectionTitle;
